import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=2e878a7d&scoped=true"
import script from "./ImageComponent.vue?vue&type=script&lang=js"
export * from "./ImageComponent.vue?vue&type=script&lang=js"
import style0 from "./ImageComponent.vue?vue&type=style&index=0&id=2e878a7d&prod&scoped=true&lang=css"
import style1 from "./ImageComponent.vue?vue&type=style&index=1&id=2e878a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e878a7d",
  null
  
)

export default component.exports